import styled from 'styled-components';
import { ListboxOptionMetaMixin } from '../../mixins/components/ListboxOptionMetaMixin';

/**
 * @since 8.28.0
 */
var ListboxOptionMeta = /*#__PURE__*/styled.div.withConfig({
  displayName: "ListboxOptionMeta",
  componentId: "c11n-8-111-1__sc-1wsqhbt-0"
})(["", ""], ListboxOptionMetaMixin);
ListboxOptionMeta.displayName = 'ListboxOptionMeta';

/** @component */
export { ListboxOptionMeta };